import React, { useState, useEffect } from "react";

import Select from "react-select";
// import { privateRequest } from "../../commonApi/CommonApi";
import Swal from "sweetalert2";
import { Image_URL } from "../../commonApi/CommonApi";
import { Helmet } from "react-helmet";
import privateRequest from "../../commonApi/CommonApi";

function Costumers() {
  const [parentcat, setParentCat] = useState([]);
  const [selectedFile, setSelectdFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [deleteParentCategory, setDeleteParentCategory] = useState([]);
  const [parentCategoryGroups, setParentCategoryGroups] = useState([]);
  const [parentCategoryName, setParentCategoryName] = useState("");
  const [notice, setNotice] = useState("");
  const [selectedItemId, setSelectedItemId] = useState("");
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [status, setStatus] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [Users, setUsers] = useState([]);
  const [showMessageModal, setShowMessageModal] = useState(false);
  const [messageTitle, setMessageTitle] = useState("");
  const [messageBody, setMessageBody] = useState("");
  const [messageImage, setMessageImage] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);

  const [name, setName] = useState("");
  const [mobile, setMobile] = useState("");
  const [email, setEmail] = useState("");
  const handleClose = () => setShowModal(false);
  const handleMessageModalClose = () => {
    setShowMessageModal(false);
    setMessageTitle("");
    setMessageBody("");
    setMessageImage(null);
  };

  const handleMessageModalShow = (user) => {
    setSelectedUser(user);
    setShowMessageModal(true);
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setMessageImage(file);
    }
  };

  const handleSendMessage = async () => {
    try {
      const data = {
        title: messageTitle,
        body: messageBody,
        userId: selectedUser._id,
        image: messageImage
      };

      const response = await fetch('https://api.experts4u.in/api/v1/Notification/AddNotification', {
        method: 'POST',
        body: (() => {
          const formData = new FormData();
          formData.append('titel', data.title);
          formData.append('body', data.body);
          formData.append('user_id', data.userId);
          if (data.image) {
            formData.append('Image', data.image);
          }
          return formData;
        })()
      });

      const result = await response.json();
      
      if (result.success) {
        Swal.fire({
          icon: 'success',
          title: 'Success!',
          text: 'Notification sent successfully!'
        });
        handleMessageModalClose();
      } else {
        throw new Error(result.message || 'Failed to send notification');
      }
    } catch (error) {
      console.error('Error sending notification:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error!',
        text: error.message || 'Failed to send notification'
      });
    }
  };

  const handleShow = () => {
    setName("");
    setEmail("");
    setMobile("");
    setShowModal(true);
  };

  const getUsers = async () => {
    try {
      const response = await privateRequest.get("Appregister/getAllUser");
      setUsers(response?.data?.data);
    } catch (error) {
      console.error("Error fetching parent category groups:", error);
    }
  };

  useEffect(() => {
    getUsers();
  }, []);

  const AddUsers = async (event) => {
    event.preventDefault();
    let body = {
      name: name,
      email: email,
      mobileNo: mobile,
    };
    try {
      let response = await privateRequest.post(`Appregister/AddNewUser`, body);
      getUsers();

      console.log("POST/PUT Response:", response);

      setShowModal(false);
      Swal.fire({
        icon: "success",
        title: "Success!",
        text: "User added successfully!",
      });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: error?.response?.data?.message,
      });
      console.error("Add Error:", error);
    }
  };
  return (
    <>
      {Users?.length > 0 && (
        <Helmet>
          <script>new DataTable("#my_table");</script>
        </Helmet>
      )}
      <div className="app-main">
        <div className="wrapper">
          <div className="page">
            <div className="page-inner">
              <div className="container-fluid">
                <header className="page-title-bar">
                  <div className="d-flex flex-column flex-md-row">
                    <p className="lead mb-0">
                      <span className="font-weight-bold">All Costumers</span>
                    </p>
                    <button
                      className="btn btn-primary btn-sm ml-auto"
                      onClick={handleShow}
                    >
                      <i className="fa fa-plus mr-2"></i>Add New
                    </button>
                  </div>
                </header>
                <div className="page-section">
                  <div className="card" style={{ borderRadius: "15px" }}>
                    <div className="card-body table-responsive">
                      <table
                        id="my_table"
                        className="table table-striped table-hover table-sm dataTable no-footer "
                      >
                        <thead className="bg-primary text-white">
                          <tr>
                            <th scope="col">Sr No</th>
                            <th scope="col">
                              <i className="fa fa-image">profile</i>
                            </th>
                            <th scope="col" style={{ width: "200px" }}>
                              Name
                            </th>
                            <th scope="col">Email</th>
                            <th scope="col">Mobile No.</th>
                            <th scope="col">Created</th>
                            <th scope="col">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {Users?.map((item, index) => (
                            <tr key={index}>
                              <td className="align-center">{index + 1}</td>
                              <td className="align-center">
                                {item?.photo && (
                                  <img
                                    src={`${Image_URL}${item?.photo}`}
                                    alt="Category Image"
                                    className="rounded-pill"
                                    height="50"
                                    width="50"
                                  />
                                )}
                              </td>
                              <td className="align-center">
                                <span className="mr-1 badge badge-primary">
                                  {item?.name}
                                </span>
                              </td>

                              <td className="align-center">{item?.email}</td>
                              <td className="align-center">{item.mobileNo}</td>

                              <td className="align-center">
                                <p className="mb-0">
                                  {item?.PCCreatedBy?.name}
                                </p>
                                <p className="mb-0">
                                  {new Date(item.createdAt).toLocaleDateString(
                                    "en-US",
                                    {
                                      day: "numeric",
                                      month: "long",
                                      year: "numeric",
                                    }
                                  )}
                                </p>
                              </td>
                              <td className="align-center">
                                <div className="btn-group">
                                  <button
                                    className="btn btn-info btn-sm"
                                    title="Send Message"
                                    onClick={() => {
                                      handleMessageModalShow(item);
                                    }}
                                  >
                                    <i className="fa fa-paper-plane"></i>
                                  </button>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* All Modals */}
      {showModal && (
        <div className="modal show d-block" role="dialog">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Add New User</h5>
                <button type="button" className="close" onClick={handleClose}>
                  <span>&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <form onSubmit={AddUsers}>
                  <div className="form-group">
                    <label htmlFor="mobileNo">Mobile No.</label>
                    <input
                      type="tel"
                      className="form-control"
                      id="mobileNo"
                      placeholder="Enter mobile number"
                      value={mobile}
                      required
                      onChange={(e) => {
                        setMobile(e.target.value);
                      }}
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="name">Name</label>
                    <input
                      type="text"
                      className="form-control"
                      id="name"
                      placeholder="Enter name"
                      value={name}
                      onChange={(e) => {
                        setName(e.target.value);
                      }}
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="email">Email</label>
                    <input
                      type="email"
                      className="form-control"
                      id="email"
                      placeholder="Enter email"
                      value={email}
                      onChange={(e) => {
                        setEmail(e.target.value);
                      }}
                    />
                  </div>
                  <button type="submit" className="btn btn-success">
                    Submit
                  </button>
                </form>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={handleClose}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* Message Modal */}
      <div
        className={`modal fade ${showMessageModal ? "show" : ""}`}
        style={{ display: showMessageModal ? "block" : "none" }}
        tabIndex="-1"
        role="dialog"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">
                Send Message to {selectedUser?.name}
              </h5>
              <button
                type="button"
                className="close"
                onClick={handleMessageModalClose}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <form>
                <div className="form-group">
                  <label>Title</label>
                  <input
                    type="text"
                    className="form-control"
                    value={messageTitle}
                    onChange={(e) => setMessageTitle(e.target.value)}
                    placeholder="Enter message title"
                  />
                </div>
                <div className="form-group">
                  <label>Message Body</label>
                  <textarea
                    className="form-control"
                    value={messageBody}
                    onChange={(e) => setMessageBody(e.target.value)}
                    placeholder="Enter your message"
                    rows="4"
                  />
                </div>
                <div className="form-group">
                  <label>Image</label>
                  <input
                    type="file"
                    className="form-control"
                    accept="image/*"
                    onChange={handleImageChange}
                  />
                </div>
              </form>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={handleMessageModalClose}
              >
                Close
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleSendMessage}
              >
                Send Message
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Costumers;
